import type { CSSProperties, ReactNode } from 'react';

/** Шапка экрана: заголовок, счётчик, действия справа. */
export function PageHeader({
  title,
  count,
  children,
  before,
}: {
  title: string;
  count?: number;
  /** Действия — уходят вправо за распоркой */
  children?: ReactNode;
  /** То, что встаёт сразу за заголовком: даты, плашка состояния */
  before?: ReactNode;
}) {
  return (
    <div className="top">
      <h1 className="h1">{title}</h1>
      {count !== undefined ? <span className="cnt">{count}</span> : null}
      {before}
      {children ? (
        <>
          <div className="sp" />
          {children}
        </>
      ) : null}
    </div>
  );
}

export function Breadcrumbs({ items }: { items: { label: string; onClick?: () => void }[] }) {
  return (
    <div className="crumb">
      {items.map((item, i) => (
        <span key={item.label} style={{ display: 'contents' }}>
          {i > 0 ? <span className="sepr">/</span> : null}
          {item.onClick ? (
            <a onClick={item.onClick}>{item.label}</a>
          ) : (
            <span className="cur">{item.label}</span>
          )}
        </span>
      ))}
    </div>
  );
}

export function Segments<T extends string>({
  items,
  value,
  onChange,
}: {
  items: { value: T; label: string; count?: number }[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    <div className="segs">
      {items.map((s) => (
        <span
          key={s.value}
          className={s.value === value ? 'seg on' : 'seg'}
          onClick={() => onChange(s.value)}
        >
          {s.label}
          {s.count !== undefined ? <span className="c"> {s.count}</span> : null}
        </span>
      ))}
    </div>
  );
}

/** Пара ключ-значение. */
export function Kv({
  k,
  children,
  block,
}: {
  k: string;
  children: ReactNode;
  /** Подпись отдельной строкой — только для длинных значений вроде адреса */
  block?: boolean;
}) {
  return (
    <div className={block ? 'kv kvb' : 'kv'}>
      <div className="k">{k}</div>
      <div className="v">{children}</div>
    </div>
  );
}

/** Пары в две колонки. С кита 2.3 линий под парами нет. */
export function KvGrid({ children }: { children: ReactNode }) {
  return <div className="kv2">{children}</div>;
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return <div className="sec">{children}</div>;
}

export function Divider() {
  return <div className="hair" />;
}

/** Паспорт объекта: колонки «подпись — значение», по умолчанию четыре; `columns` — переменная `--n` кита. */
export function Facts({ air, columns, children }: { air?: boolean; columns?: number; children: ReactNode }) {
  return (
    <div className={air ? 'facts air' : 'facts'} style={columns ? ({ '--n': columns } as CSSProperties) : undefined}>
      {children}
    </div>
  );
}

export function Fact({ label, sub, children }: { label: string; sub?: ReactNode; children: ReactNode }) {
  return (
    <div>
      <div className="l">{label}</div>
      <div className="v">{children}</div>
      {sub ? <div className="s">{sub}</div> : null}
    </div>
  );
}

/** Две колонки: содержимое и врезка справа. */
export function Columns({ form, children }: { form?: boolean; children: ReactNode }) {
  return <div className={form ? 'cols cols-form' : 'cols'}>{children}</div>;
}
